var merge = require("lodash.merge");

const layout = {
  plot_bgcolor: "#121212",
  paper_bgcolor: "#121212",
  //colorway: ["#FFE1CC"],
  titlefont: {
    size: 16,
    color: "#F4F5F5"
  },
  xaxis: {
    rangeslider: {
      visible: false,
      borderwidth: 0
    },
    gridcolor: "#9E9E9E",
    zerolinecolor: "#E0E0E0",
    titlefont: {
      color: "#424242",
      size: 12
    },

    tickfont: {
      color: "#757575",
      size: 12
    },

    showgrid: false
  },
  yaxis: {
    rangeslider: {
      visible: false,
      borderwidth: 0
    },
    gridcolor: "#9E9E9E",
    zerolinecolor: "#E0E0E0",
    titlefont: {
      color: "#424242",
      size: 12
    },

    tickfont: {
      color: "#757575",
      size: 12
    },

    showgrid: false
  }
};

export const styledLayout = baseLayout => {
  return merge(baseLayout, layout);
};
